module.exports = __webpack_public_path__ + "media/country_flags/tw-58e859f7.png";